import React from 'react';
import PropTypes from 'prop-types';
import SpotUtils from 'utils/spot';
import MultiRateChooser from './MultiRateChooser';

const ParkingOptionsMonthly = ({
    availableRates,
    selectedRate,
    onMultiRateChange,
    onRateDetailsClick,
}) => {
    const {
        title,
        display_price: displayPrice,
        currency_type: currencyType,
    } = selectedRate;
    const displayPriceFormatted = SpotUtils.formatRatePrice({
        price: displayPrice,
        currencyType,
    });

    return (
        <div className="ParkingOptions">
            <h3 className="ParkingOptions-header">Parking Options</h3>
            {availableRates.length > 1 && (
                <MultiRateChooser
                    selectedRate={selectedRate}
                    rates={availableRates}
                    priceLabel="/mo"
                    onMultiRateChange={onMultiRateChange}
                    onInfoButtonClick={onRateDetailsClick}
                />
            )}
            {availableRates.length === 1 && (
                <div className="ParkingOption-single">
                    <div className="ParkingOption-content">
                        <span className="ParkingOption-title">{title}</span>
                        <span className="ParkingOption-price-with-label">
                            <span
                                className="ParkingOption-price"
                                dangerouslySetInnerHTML={{
                                    __html: displayPriceFormatted,
                                }}
                            />
                            <span className="ParkingOption-price-label">
                                /mo
                            </span>
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

ParkingOptionsMonthly.propTypes = {
    availableRates: PropTypes.arrayOf(PropTypes.object),
    selectedRate: PropTypes.object,
    onMultiRateChange: PropTypes.func,
    onRateDetailsClick: PropTypes.func,
};

export default ParkingOptionsMonthly;
